export const SERVICES = [
  {
    slug: "tree-service-land-clearing",
    name: "Tree Service / Land Clearing",
    tagline: "Takedowns, pruning, and full lot clearing.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/lcpzj5xj_IMG_9350.jpeg",
    overviewImage:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/xi5ttog6_IMG_4239.webp",
    photos: [
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/b0u3d76l_IMG_9351.jpeg" },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/3ujd4pyr_IMG_9349.jpeg" },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/oe6q3lz3_IMG_9344.jpeg" },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/gtgvya1r_IMG_1953.jpeg" },
    ],
    description:
      "Safe, professional tree removal and land clearing for residential and commercial properties. From a single problem tree to clearing an entire lot for a new build — we've got the equipment and crew to handle it.",
    bullets: [
      "Tree takedowns and safe removal",
      "Stump grinding and hauling",
      "Pruning, shaping, and dead-limb removal",
      "Brush, overgrowth, and lot clearing",
    ],
    process: [
      "Free on-site walk-through and quote",
      "Utility and property line check",
      "Careful takedown and cleanup",
      "Full haul-off — site left clean",
    ],
  },
  {
    slug: "sealcoating",
    name: "Sealcoating",
    tagline: "Restore and protect your driveway.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/075edkjc_IMG_8947.webp",
    overviewImage:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/6lmgckxj_IMG_5653.webp",
    overviewRotate: 90,
    photos: [
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/75exstnc_IMG_8395.webp", rotate: 90 },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/ywa837yf_IMG_7842.webp" },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/up5s8g25_IMG_7257.webp" },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/1feilsst_D23341BF-85BC-4805-A15F-356C8236730E.png" },
    ],
    description:
      "A fresh sealcoat protects your asphalt from UV damage, water intrusion, oil stains, and cracking — extending the life of your driveway by years while making it look brand new.",
    bullets: [
      "Commercial-grade sealer with UV inhibitors",
      "Deep crack repair and pothole patching",
      "Edging, oil-spot priming, and hand-detail work",
      "Driveways, parking lots, and private roads",
    ],
    process: [
      "Free on-site estimate and evaluation",
      "Power-clean and prep the surface",
      "Fill cracks and repair damaged areas",
      "Apply two coats of premium sealer",
      "Cure for 24 hours — good as new",
    ],
  },
  {
    slug: "landscaping",
    name: "Landscaping",
    tagline: "Beds, mulching, and property design.",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/dbnomgm9_IMG_5800.webp",
    overviewImage:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/690bj3w3_IMG_3738.webp",
    photos: [
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/q9g9csko_IMG_8904.webp", rotate: 90 },
      null,
      null,
      null,
    ],
    description:
      "From fresh mulch installs to full landscape design, we shape outdoor spaces that boost curb appeal and hold up season after season.",
    bullets: [
      "Mulch and stone bed installation",
      "Bed edging and weed barrier",
      "Shrub and plant installation",
      "Bush trimming and hedge maintenance",
    ],
    process: [
      "Walk the property and understand your vision",
      "Detailed written estimate",
      "Prep beds, edge, and lay weed barrier",
      "Install mulch, stone, or plantings",
      "Final cleanup — we leave it better than we found it",
    ],
  },
  {
    slug: "lawn-care",
    name: "Lawn Care",
    tagline: "Mowing, Turf Treatments, Aeration, Seeding, Topsoil Dressing",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/stwk8yk2_IMG_4521.webp",
    overviewImage:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/d1ft56n7_IMG_5046.jpeg",
    photos: [
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/v8ec5exx_IMG_9704.webp" },
      { src: "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/im6b3eob_IMG_5731.jpeg" },
      null,
      null,
    ],
    description:
      "Consistent, professional lawn maintenance from spring through fall. A perfectly striped lawn all season long that'll make your neighbor's jealous!",
    bullets: [
      {
        heading: "Mowing",
        items: [
          "Weekly or bi-weekly mowing",
          "Mowing of property",
          "Edging/trimming of sidewalks, walkways, objects",
          "Blowing off all walkways, patios, driveway of grass",
        ],
      },
      {
        heading: "Turf Treatments",
        items: [
          "Fertilization",
          "Weed control",
          "Aeration",
          "Overseeding",
          "Topsoil Dressing",
        ],
      },
    ],
    process: [
      "Free property walk-through",
      "Lock in a weekly service day",
      "Full-service mow, edge, and blow every visit",
      "Same crew every week — we know your yard",
    ],
  },
  {
    slug: "cleanups",
    name: "Spring & Fall Cleanups",
    tagline: "Reset your property for the next season.",
    image:
      "https://customer-assets.emergentagent.com/job_fb11634d-0cf3-4470-a5e6-878c1ff83f74/artifacts/8p036287_IMG_0672.jpeg",
    description:
      "Two big pushes a year to keep your property clean, healthy, and ready for whatever the weather brings.",
    bullets: [
      "Full leaf removal and hauling",
      "Bed cleanouts and gutter clearing",
      "Storm debris and stick pickup",
      "Pre-winter and spring turf prep",
    ],
    process: [
      "Schedule a spring or fall block",
      "Full property blow-out and haul-off",
      "Bed cleanout, edging, and mulch touch-up (add-on)",
      "Property left photo-ready",
    ],
  },
  {
    slug: "snow-removal",
    name: "Snow Removal / Ice Management",
    tagline: "24/7 Snow Removal",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/drelfu7j_20260126_093920336_iOS.webp",
    overviewImage:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rapid-property-pro/artifacts/c7nbg3eo_IMG_9283.jpeg",
    description:
      "Our numerous Snow Response teams, work day and night to clear parking lots, sidewalks, and driveways to ensure safety at your business or residence.",
    bullets: [
      {
        heading: "Commercial Snow Removal",
        items: [
          "Parking Lots/Roadways",
          "Walkways",
          "Salting",
        ],
      },
      {
        heading: "Residential Snow Removal",
        items: [
          "Driveways",
          "Walkways",
          "Salting",
        ],
      },
    ],
    process: [
      "Sign a Snow Removal Contract",
      "You're then added to our route",
      "Automatic dispatch at trigger snow depth",
      "Post-storm salting and clean-up pass",
      "You will be notified once your business/residence is cleared!",
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
